import publicApi from './publicApi';

// Cache for chart data - 3 minutes TTL
const chartCache = new Map();
const CACHE_TTL = 3 * 60 * 1000; // 3 minutes in milliseconds

// Public chart service for non-authenticated users
export async function getPublicChart(symbol, range = '24h', points = 24) {
  try {
    // Create cache key
    const cacheKey = `${symbol}-${range}-${points}`;
    
    // Check if we have cached data that's still valid
    const cached = chartCache.get(cacheKey);
    if (cached && (Date.now() - cached.timestamp) < CACHE_TTL) {
      return cached.data;
    }
    
    // Fetch fresh data
    const url = `/api/public/coins/${symbol}/chart?range=${range}&points=${points}&optimize=true`;
    const res = await publicApi.get(url);
    
    // Cache the result
    chartCache.set(cacheKey, {
      data: res.data,
      timestamp: Date.now()
    });
    
    return res.data;
  } catch (error) {
    console.error(`[PublicChartService] Error fetching ${symbol}:`, error.message);
    throw error;
  }
}

// Get 24h price change percentage from chart data
export function calculate24hChange(chartData) {
  if (!chartData || !chartData.data || chartData.data.length < 2) {
    return 0;
  }
  
  const data = chartData.data;
  const firstPrice = data[0].close;
  const lastPrice = data[data.length - 1].close;
  
  if (firstPrice <= 0) return 0;
  
  return ((lastPrice - firstPrice) / firstPrice) * 100;
} 